module.exports = __webpack_public_path__ + "img/next-loot-5.4f895130.png";